import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Divider, Button, Switch, Popconfirm } from "antd";
import { DownloadOutlined, PlusOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import InspectionApi from '@api/inspect'
import { stationApi, } from "@api/newApi";
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import { getStationData } from '@utils/common'
// import AddModel from './add'
// import './style.scss'

const types = ['维修技工', '场站经理']
const InspectionCom = (props) => {
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(true)
  const [totalData, setTotalData] = useState({})
  const [editTitle, setEditTitle] = useState('新建模版')
  const [rowParams, setRowParams] = useState()
  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)


  // 搜索
  // const [inputList] = useState([{
  //   label: '站点:',
  //   name: "stationId",
  //   message: "请输入部门ID",
  //   span: 8,
  //   labelCol: 6
  // }])
  const [selectList, setSelectList] = useState()

  const [stationData, setStationData] = useState()

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '站点:',
        name: "stationId",
        message: "请选择站点",
        options: data,
        span: 8,
        labelCol: 6
      },

    ])
    setStationData(data)
  }
  const [inputList] = useState([
    {
      attr: { allowClear: true },
      label: '标准名称:',
      name: "name",
      message: "请输入名称",
      span: 8,
      labelCol: 6
    }
  ])
  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    // const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    InspectionApi.standQuery({ ...searchParams, }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data.data || [])
        setTotal(res.total)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    console.log(paramsObj, 'paramsObj')
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = (id) => {
    setLoadBtn(true)
    InspectionApi.delete(id).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancel = () => {
    setDelVisible(false)
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (info) => {
    InspectionApi.updateStatus({ id: (info.id * 1), status: info.status === 0 ? 1 : 0 }).then(res => {
      if (res.status === '0') {
        message.success('修改成功')
        listByRole()
      }
    })
  }


  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    onClick: () => {
      console.log(props)

      props.history.push('/inspect/standard/add')
    }
  }]

  const columns = [
    {
      title: '巡检标准名称',
      dataIndex: 'name',
      align: 'center',
      key: 'name',
      render: (obj, record) => {
        return <span> {types[obj]}</span>
      }
    },
    {
      title: '模版ID',
      dataIndex: 'templateId',
      align: 'center',
      key: 'templateId',
    },

    {
      title: '设备ID',
      dataIndex: 'deviceId',
      align: 'center',
      key: 'deviceId',
    },
    {
      title: '执行角色',
      dataIndex: 'handleRoleName',
      align: 'center',
      key: 'handleRoleName',
    },

    {
      title: '场站',
      dataIndex: 'stationId',
      align: 'center',
      key: 'stationId',
      // render: (obj, record) => {
      //   return <span style={{ color: obj !== 0 ? 'green' : 'red' }}> {obj !== 0 ? '启用' : '禁用'}</span>
      // }
    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'createAt',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '操作',
      key: 'operation',
      width: '200px',
      fixed: 'right',
      render: (obj, record) => {
        return (
          <>
            <Popconfirm
              title={`确定要${obj.status === 0 ? '启用' : '禁用'}模版吗？`}
              onConfirm={() => handleConfirm(record)}
              // onCancel={cancel}
              okText="确定"
              cancelText="取消"
            >
              <Button size='small' type="primary">{obj.status === 0 ? '启用' : '禁用'}</Button>
            </Popconfirm>
            <Button
              style={{ marginLeft: '5px' }}
              onClick={() => {
                setDelVisible(true)
                setRowParams(record)
              }
              }
              size='small'
              type='primary'>删除
            </Button>
          </>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="站点列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm searchParams={searchParams} span={6} inputList={inputList} selectList={selectList} onSearch={search} />
        </div>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {
          deleteVisible &&
          <Modal
            title='删除站点'
            width={420}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={() => deletes(rowParams.id)}>
            <div style={{ textAlign: 'center', color: "red" }}>
              <p>{`确定要删除巡检模版【${rowParams.templateName}】吗？`}</p>
            </div>
          </Modal>
        }
        {/* {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />} */}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(InspectionCom)
